import { success, error, abort } from 'redux-saga-requests';
import { AXIS_QUERY, AXIS_CL_QUERY } from '../constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case AXIS_QUERY:
    case AXIS_CL_QUERY: {
      return {
        ...state,
        [action.meta.name]: {
          response: state[action.meta.name] ? state[action.meta.name].response : undefined,
          resolved: false,
          failed: false,
          error: null,
        },
      };
    }
    case success(AXIS_QUERY):
    case success(AXIS_CL_QUERY): {
      return {
        ...state,
        [action.meta.name]: {
          response: action.payload.data,
          resolved: true,
          failed: false,
          error: null,
        },
      };
    }
    case error(AXIS_QUERY):
    case error(AXIS_CL_QUERY): {
      if (action.payload.response.status >= 400 && action.payload.response.status < 600) {
        return {
          ...state,
          [action.meta.name]: {
            resolved: true,
            failed: true,
            error: action.payload.response.data.result.errorCode,
          },
        };
      }
      return {
        ...state,
        [action.meta.name]: {
          resolved: true,
          failed: true,
          error: action.payload.toString ? action.payload.toString() : '',
        },
      };
    }
    case abort(AXIS_QUERY):
    case abort(AXIS_CL_QUERY):
      return {
        ...state,
      };
    default:
      return state;
  }
}
